<template>
  <div class="animated fadeIn">
    <Forms ref="frmGroup"
      :title="'CADASTRO DE PESSOAS'"
      :showClearButton="true"
      :showSaveButton="true"
      :showBackButton="true"
      v-on:Clear="onClear"
      v-on:Back="onBack"
      v-on:Save="onSave">

      <div class="form-group row">

        <div class="col-md-9">
          <label for="txtName"><small v-show="form.nome.required" class="text-danger">*</small> Nome Completo:</label>
          <div class="input-group">
            <b-form-input type="text"
                          :placeholder="'Digite o Nome Completo'"
                          v-model="form.nome.value"
                          :size="form.nome.maxlength"
                          :required="form.nome.required"
                          :state="form.nome.state"></b-form-input>
          </div>
        </div>

        <div class="col-md-3">
          <label for="txtName"><small v-show="form.dataNascimento.required" class="text-danger">*</small> Data de Nascimento:</label>
          <div class="input-group">
            <b-form-input type="text"
                          :placeholder="'DD/MM/AAAA'"
                          v-model="form.dataNascimento.value"
                          :size="form.dataNascimento.maxlength"
                          v-mask="'##/##/####'"
                          :required="form.dataNascimento.required"
                          :state="form.dataNascimento.state"></b-form-input>
          </div>
        </div>

      </div>

      <div class="form-group row">

        <div class="col-md-2">
          <label for="txtName"><small v-show="form.tipoPessoa.required" class="text-danger">*</small> Tipo Pessoa:</label>
          <div class="input-group">
            <b-form-select v-model="form.tipoPessoa.value" :options="form.tipoPessoa.options">
                <template slot="first">
                  <option :value="''">{{$lang.Common.PlaceholderSelect}}</option>
                </template>
            </b-form-select>
          </div>
        </div>

        <div class="col-md-3">
          <label for="txtName"><small v-show="form.document.required" class="text-danger">*</small> Numero do documento:</label>
          <div class="input-group">
            <b-form-input type="text"
                          :placeholder="'Digite o numero do documento'"
                          v-model="form.document.value"
                          v-mask="['###.###.###-##', '##.###.###/####-##']"
                          :required="form.document.required"
                          :state="form.document.state"
                          @change="validateDocument(form.document)"></b-form-input>
          </div>
        </div>

        <div class="col-md-7">
          <label for="txtName"><small v-show="form.email.required" class="text-danger">*</small> E-mail:</label>
          <div class="input-group">
            <b-form-input type="email"
                          :placeholder="'Digite o E-mail'"
                          v-model="form.email.value"
                          :size="form.email.maxlength"
                          :required="form.email.required"
                          :state="form.email.state"></b-form-input>
          </div>
        </div>

        <div class="col-md-12 mt-1">
          <label for="txtName"><small v-show="form.siteUrl.required" class="text-danger">*</small> Site:</label>
          <div class="input-group">
            <b-form-input type="url"
                          :placeholder="'Digite o site'"
                          v-model="form.siteUrl.value"
                          :size="form.siteUrl.maxlength"
                          :required="form.siteUrl.required"
                          :state="form.siteUrl.state"></b-form-input>
          </div>
        </div>
      </div>

      <div class="form-group row" v-for="(telefone, index) in formTelefone" :key="index + 'telefone'">
        <div class="col-md-4">
          <label for="txtName"><small v-show="telefone.tipoContato.required" class="text-danger">*</small> Tipo Telefone:</label>
          <div class="input-group">
            <b-form-select v-model="telefone.tipoContato.value" :options="telefone.tipoContato.options">
                <template slot="first">
                  <option :value="''">{{$lang.Common.PlaceholderSelect}}</option>
                </template>
            </b-form-select>
          </div>
        </div>

        <div class="col-md-6">
          <label for="txtName"><small v-show="telefone.telefone.required" class="text-danger">*</small> Telefone:</label>
          <div class="input-group">
            <b-form-input type="text"
                          :placeholder="'Digite o numero de telefone'"
                          v-model="telefone.telefone.value"
                          v-mask="['(##) ####-####', '(##) #####-####']"
                          :required="telefone.telefone.required"
                          :state="telefone.telefone.state"></b-form-input>
          </div>
        </div>
        <div class="col-md-1 mt-4">
          <i
            v-on:click="onDeleteTelefone(telefone)"
            class="fa fa-trash text-danger icone-grid"
            v-b-tooltip.hover
            :title="'Clique para remover o telefone'"
          ></i>
        </div>
      </div>
      <div class="col-md-2 pt-3">
        <button
          type="button"
          class="btn btn-third btn-sm"
          v-on:click="onCreateNewTelefoneForm()"
          v-b-tooltip.hover
        >
          <i class="fas fa-plus"></i> <span> Adicionar Telefone</span>
        </button>
      </div>
      <br>

      <div v-for="(endereco, index) in formEndereco" :key="index" class="border p-3 mb-3">
        <div class="form-group row">
          <div class="col-md-6">
            <label for="txtName"><small v-show="endereco.cep.required" class="text-danger">*</small> CEP:</label>
            <div class="input-group">
              <b-form-input type="text"
                            :placeholder="'Digite o CEP'"
                            v-model="endereco.cep.value"
                            v-mask="'#####-###'"
                            :required="endereco.cep.required"
                            :state="endereco.cep.state"
                            @change="onSetCepSearch(endereco)"></b-form-input>
            </div>
          </div>
        </div>

        <div class="form-group row d-flex flex-wrap">

          <div class="col-md-6">
            <label for="txtName"><small v-show="endereco.endereco.required" class="text-danger">*</small> Endereço:</label>
            <div class="input-group">
              <b-form-input type="text"
                            :placeholder="'Digite o endereço'"
                            v-model="endereco.endereco.value"
                            :size="endereco.endereco.maxlength"
                            :required="endereco.endereco.required"
                            :state="endereco.endereco.state"></b-form-input>
            </div>
          </div>

          <div class="col-md-2">
            <label for="txtName"><small v-show="endereco.numero.required" class="text-danger">*</small> Numero:</label>
            <div class="input-group">
              <b-form-input type="text"
                            :placeholder="'Nº'"
                            v-model="endereco.numero.value"
                            :size="endereco.numero.maxlength"
                            :required="endereco.numero.required"
                            :state="endereco.numero.state"></b-form-input>
            </div>
          </div>

          <div class="col-md-1">
            <label for="txtName"><small v-show="endereco.uf.required" class="text-danger">*</small> UF:</label>
            <div class="input-group">
              <b-form-input type="text"
                            :placeholder="'UF'"
                            v-model="endereco.uf.value"
                            :maxlength="endereco.uf.maxlength"
                            :required="endereco.uf.required"
                            :state="endereco.uf.state"></b-form-input>
            </div>
          </div>
          <div class="col-md-3">
            <label for="txtName"><small v-show="endereco.municipio.required" class="text-danger">*</small> Município:</label>
            <div class="input-group">
              <b-form-input type="text"
                            :placeholder="'Digite o Município'"
                            v-model="endereco.municipio.value"
                            :size="endereco.municipio.maxlength"
                            :required="endereco.municipio.required"
                            :state="endereco.municipio.state"></b-form-input>
            </div>
          </div>
        </div>

        <div class="form-group row">
          <div class="col-md-2">
            <label for="txtName"><small v-show="endereco.tipoLogradouro.required" class="text-danger">*</small> Tipo Logradouro:</label>
            <div class="input-group">
              <b-form-input type="text"
                            :placeholder="'Digite o tipo do logradouro'"
                            v-model="endereco.tipoLogradouro.value"
                            :size="endereco.tipoLogradouro.maxlength"
                            :required="endereco.tipoLogradouro.required"
                            :state="endereco.tipoLogradouro.state"></b-form-input>
            </div>
          </div>

          <div class="col-md-3">
            <label for="txtName"><small v-show="endereco.logradouro.required" class="text-danger">*</small> Logradouro:</label>
            <div class="input-group">
              <b-form-input type="text"
                            :placeholder="'Digite o Logradouro'"
                            v-model="endereco.logradouro.value"
                            :size="endereco.logradouro.maxlength"
                            :required="endereco.logradouro.required"
                            :state="endereco.logradouro.state"></b-form-input>
            </div>
          </div>

          <div class="col-md-2">
            <label for="txtName"><small v-show="endereco.complemento.required" class="text-danger">*</small> Complemento:</label>
            <div class="input-group">
              <b-form-input type="text"
                            :placeholder="'Digite o Complemento'"
                            v-model="endereco.complemento.value"
                            :size="endereco.complemento.maxlength"
                            :required="endereco.complemento.required"
                            :state="endereco.complemento.state"></b-form-input>
            </div>
          </div>

          <div class="col-md-3">
            <label for="txtName"><small v-show="endereco.bairro.required" class="text-danger">*</small> Bairro:</label>
            <div class="input-group">
              <b-form-input type="text"
                            :placeholder="'Digite o Bairro'"
                            v-model="endereco.bairro.value"
                            :size="endereco.bairro.maxlength"
                            :required="endereco.bairro.required"
                            :state="endereco.bairro.state"></b-form-input>
            </div>
          </div>

          <div class="col-md mt-4" align-self='end'>
            <i v-on:click="onDeleteEndereco(endereco)" class="fa fa-trash text-danger icone-grid" v-b-tooltip.hover :title="'Clique para remover o endereço'"></i>
          </div>

        </div>
      </div>
      <div class="col-md-2">
        <button
          type="button"
          class="btn btn-third btn-sm"
          v-on:click="onCreateNewEnderecoForm()"
          v-b-tooltip.hover
        >
          <i class="fas fa-plus"></i> <span> Adicionar Endereco</span>
        </button>
      </div>

      <div v-for="(pontofocal, index) in formPontoFocal" :key="index + 'pontoFocal'"  class="border p-3 mb-3 mt-3">
        <div class="form-group row">
          <div class = "col-md">
            <label for="txtName"><small v-show="pontofocal.document.required" class="text-danger">*</small> CPF:</label>
            <div class="input-group">
              <b-form-input type="text"
                            :placeholder="'Digite o CPF'"
                            v-model="pontofocal.document.value"
                            v-mask="pontofocal.document.mask"
                            :required="pontofocal.document.required"
                            :state="pontofocal.document.state"
                            @change="onSearchPontoFocal(pontofocal)"
                            ></b-form-input>
            </div>
          </div>
          <div class = "col-md-9">
            <label for="txtName"><small v-show="pontofocal.nome.required" class="text-danger">*</small> Nome:</label>
            <div class="input-group">
              <b-form-input type="text"
                            :placeholder="'Digite o Nome Completo'"
                            v-model="pontofocal.nome.value"
                            :required="pontofocal.nome.required"
                            :state="pontofocal.nome.state"
                            ></b-form-input>
            </div>
          </div>
        </div>
        <div class ="form-group row">
          <div class = "col-md-2">
            <label for="txtName"><small v-show="pontofocal.dataNascimento.required" class="text-danger">*</small>Data de Nascimento:</label>
            <div class="input-group">
              <b-form-input type="text"
                            :placeholder="'DD/MM/AAAA'"
                            v-model="pontofocal.dataNascimento.value"
                            v-mask="pontofocal.dataNascimento.mask"
                            :required="pontofocal.dataNascimento.required"
                            :state="pontofocal.dataNascimento.state"
                            ></b-form-input>
            </div>
          </div>
          <div class = "col-md-7">
            <label for="txtName"><small v-show="pontofocal.email.required" class="text-danger">*</small>E-mail:</label>
            <div class="input-group">
              <b-form-input type="text"
                            :placeholder="'Insira o E-mail'"
                            v-model="pontofocal.email.value"
                            :required="pontofocal.email.required"
                            :state="pontofocal.email.state"
                            ></b-form-input>
            </div>
          </div>
          <div class="col-md-3">
          <label for="txtName"><small v-show="pontofocal.telefone.required" class="text-danger">*</small> Telefone:</label>
          <div class="input-group">
            <b-form-input type="text"
                          :placeholder="'Digite o numero de telefone'"
                          v-model="pontofocal.telefone.value"
                          v-mask="['(##) ####-####', '(##) #####-####']"
                          :required="pontofocal.telefone.required"
                          :state="pontofocal.telefone.state"></b-form-input>
          </div>
        </div>
        </div>
        <div class ="form-group row">
          <div class="col-md-4">
          <label for="txtName"><small v-show="pontofocal.cargo.required" class="text-danger">*</small> Cargo:</label>
          <div class="input-group">
            <v-select v-model="pontofocal.cargo.value" :options="pontofocal.cargo.options" class="w-100" label="text"
              :reduce="(opt) => opt.value">
              <template v-slot:no-options>Nenhum cargo encontrado.</template>
            </v-select>
          </div>
        </div>
        <div class="col-md mt-4" align-self='end'>
            <i v-on:click="onDeletePontoFocal(pontofocal)" class="fa fa-trash text-danger icone-grid" v-b-tooltip.hover :title="'Clique para remover o ponto focal'"></i>
          </div>
        </div>
      </div>
      <div class="col-md-2 pt-3">
        <button
          type="button"
          class="btn btn-third btn-sm" v-on:click="onCreateNewPontoFocal()"
          v-b-tooltip.hover
        >
          <i class="fas fa-plus"></i> <span> Adicionar Ponto Focal</span></button>
      </div>

      <div
        v-for="(alfanumerico, index) in formAlfanumerico"
        :key="'A'+index"
        class="border p-3 mt-3"
      >
        <div class="col-md-100">
          <div class="input-group w-100">
            <b-form-textarea
              id="textarea-auto-height"
              rows="4"
              max-rows="8"
              v-model="alfanumerico.alfanumerico.value"
              :required="alfanumerico.alfanumerico.required"
              :state="alfanumerico.alfanumerico.state"
            ></b-form-textarea>
          </div>
        </div>

        <div class="col-md-1 mt-4">
          <i
            v-on:click="onDeleteAlfanumerico(alfanumerico)"
            class="fa fa-trash text-danger icone-grid"
            v-b-tooltip.hover
            :title="'Clique para remover o campo alfanumérico'"
          ></i>
        </div>
      </div>
      <div class="col-md-2 pt-3">
        <button
          type="button"
          class="btn btn-third btn-sm" v-on:click="onCreateNewAlfanumerico()"
          v-b-tooltip.hover
        >
          <i class="fas fa-plus"></i> <span> Adicionar campo Alfanumérico</span></button>
      </div>

      <div
        v-for="(numerico, index) in formNumerico"
        :key="'B'+index"
        class="border p-3 mt-3"
      >
        <div class="col-md">
          <div class="input-group w-100">
            <b-form-input
              type="number"
              id="textarea-auto-height"
              v-model="numerico.numerico.value"
              :required="numerico.numerico.required"
              :state="numerico.numerico.state"
            ></b-form-input>
          </div>
        </div>

        <div class="col-md-1 mt-4">
          <i v-on:click="onDeleteCampoNumerico(numerico)" class="fa fa-trash text-danger icone-grid" v-b-tooltip.hover :title="'Clique para remover o campo numérico'"></i>
        </div>
      </div>
      <div class="col-md-2 pt-3">
        <button
          type="button"
          class="btn btn-third btn-sm" v-on:click="onCreateCampoNumerico()"
          v-b-tooltip.hover
        >
          <i class="fas fa-plus"></i> <span> Adicionar campo Numérico</span></button>
      </div>
    </Forms>

  </div>
</template>
<script>
import axios from 'axios'
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import Tools from '@/components/tools/Tools.js'
import PersonModel from '@/shared/models/configurations/personmodel.js'
import PersonForms from './person-form.js'
import PersonRepository from '@/shared/http/repositories/configurations/person.js'
import PontoFocalRepository from '@/shared/http/repositories/configurations/pontofocal.js'
import TelefoneForm from './telefone-form.js'
import EnderecoForm from './endereco-form.js'
import { AlfanumericoForm, AlfanumericoData } from './alfanumerico-form.js'
import { NumericoForm, NumericoData } from './numerico-form.js'
import PontoFocal from './pontofocal-form.js'
import EnderecoData from '@/shared/models/configurations/enderecomodel.js'
import TelefoneData from '@/shared/models/configurations/telefonemodel.js'
import PontoFocalData from '@/shared/models/configurations/pontofocalmodel.js'
import { advancedOnException } from '@/components/tools/Utils'
import PositionRepository from '@/shared/http/repositories/configurations/position.js'

export default {
  name: 'AccountAdd',
  mixins: [ActionsForm],
  data () {
    return {
      data: PersonModel,
      form: PersonForms,
      formTelefone: [],
      dataTelefone: [],
      formEndereco: [],
      dataEndereco: [],
      formPontoFocal: [],
      dataPontoFocal: [],
      formAlfanumerico: [],
      dataAlfanumerico: [],
      formNumerico: [],
      dataNumerico: [],
      cargoOptions: []
    }
  },
  methods: {
    onSetPersonSearch (pontofocal) {
      loading.push()
      let document = pontofocal.document.value
      PersonRepository.GetByDocument(document.replace(/[^\d]+/g, ''))
        .then((response) => {
          if (response.data.content.length !== 0) {
            pontofocal.nome.value = response.data.content[0].nome != null ? response.data.content[0].nome : null
            pontofocal.dataNascimento.value = response.data.content[0].dataNascimento != null ? response.data.content[0].dataNascimento.split('T')[0].split('-').reverse().join('/') : null
            pontofocal.email.value = response.data.content[0].email != null ? response.data.content[0].email : null
            if (response.data.content[0].telefone && response.data.content[0].telefone.length !== 0) {
              pontofocal.telefone.telefone.value = response.data.content[0].telefone[0].telefone && response.data.content[0].telefone[0].telefone
            }
          }
        })
        .catch(e => advancedOnException(e, this.$lang))
      loading.close()
    },
    onSetCepSearch (endereco) {
      if (endereco) {
        axios.get(`https://viacep.com.br/ws/${endereco.cep.value}/json/`)
          .then((response) => {
            endereco.endereco.value = response.data.logradouro
            endereco.logradouro.value = response.data.logradouro
            endereco.uf.value = response.data.uf
            endereco.complemento.value = response.data.complemento
            endereco.municipio.value = response.data.localidade
            endereco.bairro.value = response.data.bairro
          })
      }
    },
    onBack () {
      this.$emit('Back')
    },
    onClear () {
      Tools.ClearDataForms(this.form, this.data)
      this.form.tipoPessoa.value = ''
      this.formTelefone = []
      this.formEndereco = []
      this.formPontoFocal = []
      this.onCreateNewTelefoneForm()
      this.onCreateNewEnderecoForm()

      if (this.$refs.alert) {
        this.$refs.alert.Close()
      }
    },
    onLoad () {},
    onEdit (obj) {
      loading.push()
      this.onLoad()
      this.formTelefone = []
      this.formEndereco = []
      this.formAlfanumerico = []
      this.formPontoFocal = []

      obj.dataNascimento = obj.dataNascimento && obj.dataNascimento.split('T')[0].split('-').reverse().join('/')

      Tools.SetValueInForm(this.form, this.data, obj)
      this.form.nome.value = obj.nome
      this.form.siteUrl.value = obj.siteUrl
      for (let endereco in obj.endereco) {
        this.onCreateNewEnderecoForm()
        Tools.SetValueInForm(this.formEndereco[endereco], this.dataEndereco[endereco], obj.endereco[endereco])
      }
      for (let telefone in obj.telefone) {
        this.onCreateNewTelefoneForm()
        Tools.SetValueInForm(this.formTelefone[telefone], this.dataTelefone[telefone], obj.telefone[telefone])
      }
      for (let pontoFocal in obj.pontoFocal) {
        const promisse = PositionRepository.GetAll()
          .then((response) => {
            let pontoFocal = new PontoFocal()
            pontoFocal.cargo.options = this.onResultDropdown(response, null, f => f.nome)
            this.formPontoFocal.push(pontoFocal)
            this.dataPontoFocal.push(new PontoFocalData())
            console.log('1')
          })
          .catch((err) => {
            this.onException(err)
          })
        promisse
          .then(() => {
            console.log('2')
            console.log({
              ...obj.pontoFocal[pontoFocal],
              dataNascimento: obj.pontoFocal[pontoFocal].dataNascimento.split('T')[0].split('-').reverse().join('/'),
              cargo: obj.pontoFocal[pontoFocal].cargo.id
            })
            Tools.SetValueInForm(this.formPontoFocal[pontoFocal], this.dataPontoFocal[pontoFocal], {
              ...obj.pontoFocal[pontoFocal],
              dataNascimento: obj.pontoFocal[pontoFocal].dataNascimento.split('T')[0].split('-').reverse().join('/'),
              cargo: obj.pontoFocal[pontoFocal].cargo.id
            })
          })
      }
      for (let alfanumerico in obj.alfanumerico) {
        this.onCreateNewAlfanumerico()
        this.formAlfanumerico[alfanumerico].alfanumerico.value = obj.alfanumerico[alfanumerico]
        this.dataAlfanumerico[alfanumerico].alfanumerico = obj.alfanumerico[alfanumerico]
      }
      for (let numerico in obj.numerico) {
        this.onCreateCampoNumerico()
        this.formNumerico[numerico].numerico.value = obj.numerico[numerico]
        this.dataNumerico[numerico].numerico = obj.numerico[numerico]
      }

      let setTipoPessoa = new Set(['PJ', 'PF'])
      if (!setTipoPessoa.has(obj.tipoPessoa)) {
        this.form.tipoPessoa.value = Tools.checkDocumentType(obj.document)
      }
      this.$nextTick(() => {
        this.$forceUpdate()
      })
      loading.pop()
    },
    onCreate () {
      loading.push()
      if (this.setDataForRequest()) {
        PersonRepository.Create(this.data)
          .then((response) => {
            loading.close()
            this.$emit('Back')
            toast.success(this.$lang.Common.Alerts.Success)
          })
          .catch(e => advancedOnException(e, this.$lang))
      }
      loading.close()
    },
    setDataForRequest () {
      this.data.telefone = []
      this.data.endereco = []
      this.data.pontoFocal = []
      this.data.alfanumerico = []
      this.data.numerico = []
      this.setDatetimeFormat()

      for (let endereco in this.formEndereco) {
        if (!Tools.ValidateForms(this.formEndereco[endereco], this.dataEndereco[endereco], this, toast)) {
          return false
        }
        this.data.endereco.push(this.dataEndereco[endereco])
      }
      for (let pontoFocal in this.formPontoFocal) {
        if (!Tools.ValidateForms(this.formPontoFocal[pontoFocal], this.dataPontoFocal[pontoFocal], this, toast)) {
          return false
        }
        this.data.pontoFocal.push({
          ...this.dataPontoFocal[pontoFocal],
          document: this.dataPontoFocal[pontoFocal].document.toString().replace(/[^\d]+/g, ''),
          dataNascimento: this.dataPontoFocal[pontoFocal].dataNascimento && this.dataPontoFocal[pontoFocal].dataNascimento.split('/').reverse().join('-')
        })
      }

      for (let telefone in this.formTelefone) {
        if (!Tools.ValidateForms(this.formTelefone[telefone], this.dataTelefone[telefone], this, toast)) {
          return false
        }
        this.data.telefone.push(this.dataTelefone[telefone])
      }

      this.data.document = this.data.document.toString().replace(/[^\d]+/g, '')

      for (let alfanumerico in this.formAlfanumerico) {
        if (!Tools.ValidateForms(this.formAlfanumerico[alfanumerico], this.dataAlfanumerico[alfanumerico], this, toast)) {
          return false
        }
        this.data.alfanumerico.push(this.dataAlfanumerico[alfanumerico].alfanumerico)
      }

      for (let numerico in this.formNumerico) {
        if (!Tools.ValidateForms(this.formNumerico[numerico], this.dataNumerico[numerico], this, toast)) {
          return false
        }
        this.data.numerico.push(this.dataNumerico[numerico].numerico)
      }
      return true
    },
    setDatetimeFormat () {
      if (this.data.dataNascimento) {
        let datetime = this.data.dataNascimento.split('/')
        this.data.dataNascimento = datetime.reverse().join('-')
      }
    },
    validateDocument (document) {
      if (document) {
        let documentValue = document.value.toString().replace(/[^\d]+/g, '')
        let documentValid

        if (documentValue.length === 11) {
          documentValid = this.validateCpf(documentValue)
        } else {
          documentValid = this.validateCnpj(documentValue)
        }

        if (!documentValid) {
          toast.warning('Documento inválido')
          document.value = ''
        }
      }
    },
    onUpdate () {
      loading.push()
      this.setIdsToInteger()
      this.data.id = parseInt(this.data.id)
      if (this.setDataForRequest()) {
        PersonRepository.Update(this.data)
          .then((response) => {
            loading.close()
            this.$emit('Back')
            toast.success(this.$lang.Common.Alerts.Success)
          })
          .catch(this.onException)
      }
    },
    setIdsToInteger () {
      for (let telefone in this.dataTelefone) {
        this.dataTelefone[telefone].id = parseInt(this.dataTelefone[telefone].id)
      }
      for (let endereco in this.dataEndereco) {
        this.dataEndereco[endereco].id = parseInt(this.dataEndereco[endereco].id)
      }
      for (let pontoFocal in this.dataPontoFocal) {
        this.dataPontoFocal[pontoFocal].id = parseInt(this.dataPontoFocal[pontoFocal].id)
      }
    },
    onCreateNewTelefoneForm () {
      this.formTelefone.push(new TelefoneForm())
      this.dataTelefone.push(new TelefoneData())
    },
    onDeleteTelefone (telefone) {
      let indexOfDeletion = this.formTelefone.indexOf(telefone)
      this.formTelefone.splice(indexOfDeletion, 1)
      this.dataTelefone.splice(indexOfDeletion, 1)
    },
    onCreateNewEnderecoForm () {
      let enderecoNovo = new EnderecoForm()
      this.formEndereco.push(enderecoNovo)
      this.dataEndereco.push(new EnderecoData())
    },
    onDeleteEndereco (endereco) {
      let indexOfDeletion = this.formEndereco.indexOf(endereco)
      this.formEndereco.splice(indexOfDeletion, 1)
      this.dataEndereco.splice(indexOfDeletion, 1)
    },
    onCreateNewPontoFocal () {
      PositionRepository.GetAll()
        .then((response) => {
          let pontoFocal = new PontoFocal()
          pontoFocal.cargo.options = this.onResultDropdown(response, null, f => f.nome)
          this.formPontoFocal.push(pontoFocal)
          this.dataPontoFocal.push(new PontoFocalData())
          console.log('1')
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onDeletePontoFocal (pontofocal) {
      let indexOfDeletion = this.formPontoFocal.indexOf(pontofocal)
      this.formPontoFocal.splice(indexOfDeletion, 1)
      this.dataPontoFocal.splice(indexOfDeletion, 1)
    },
    onCreateNewAlfanumerico () {
      this.formAlfanumerico.push(new AlfanumericoForm())
      this.dataAlfanumerico.push(new AlfanumericoData())
    },
    onDeleteAlfanumerico (alfanumerico) {
      let indexOfDeletion = this.formAlfanumerico.indexOf(alfanumerico)
      this.formAlfanumerico.splice(indexOfDeletion, 1)
      this.dataAlfanumerico.splice(indexOfDeletion, 1)
    },
    onCreateCampoNumerico () {
      this.formNumerico.push(new NumericoForm())
      this.dataNumerico.push(new NumericoData())
    },
    onDeleteCampoNumerico (numerico) {
      let indexOfDeletion = this.formNumerico.indexOf(numerico)
      this.formNumerico.splice(indexOfDeletion, 1)
      this.dataNumerico.splice(indexOfDeletion, 1)
    },
    validateCpf (document) {
      if (typeof document !== 'string') return false
      if (
        !document ||
        document === '00000000000' ||
        document === '11111111111' ||
        document === '22222222222' ||
        document === '33333333333' ||
        document === '44444444444' ||
        document === '55555555555' ||
        document === '66666666666' ||
        document === '77777777777' ||
        document === '88888888888' ||
        document === '99999999999'
      ) {
        return false
      }
      let soma = 0
      let resto
      for (let i = 1; i <= 9; i++) {
        soma = soma + parseInt(document.substring(i - 1, i)) * (11 - i)
      }
      resto = (soma * 10) % 11
      if (resto === 10 || resto === 11) resto = 0
      if (resto !== parseInt(document.substring(9, 10))) {
        return false
      }

      soma = 0
      for (let i = 1; i <= 10; i++) {
        soma = soma + parseInt(document.substring(i - 1, i)) * (12 - i)
      }
      resto = (soma * 10) % 11
      if (resto === 10 || resto === 11) resto = 0
      if (resto !== parseInt(document.substring(10, 11))) {
        if (resto === 0) return true
        return false
      }
      return true
    },
    validateCnpj (document) {
      if (typeof document !== 'string') return false
      if (
        !document ||
        document.length !== 14 ||
        document === '00000000000000' ||
        document === '11111111111111' ||
        document === '22222222222222' ||
        document === '33333333333333' ||
        document === '44444444444444' ||
        document === '55555555555555' ||
        document === '66666666666666' ||
        document === '77777777777777' ||
        document === '88888888888888' ||
        document === '99999999999999'
      ) {
        return false
      }

      // Valida DVs
      let tamanho = document.length - 2
      let numeros = document.substring(0, tamanho)
      let digitos = document.substring(tamanho)
      let soma = 0
      let pos = tamanho - 7
      for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--
        if (pos < 2) {
          pos = 9
        }
      }
      let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11
      if (resultado !== parseInt(digitos.charAt(0))) {
        return false
      }

      tamanho = tamanho + 1
      numeros = document.substring(0, tamanho)
      soma = 0
      pos = tamanho - 7
      for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--
        if (pos < 2) {
          pos = 9
        }
      }
      resultado = soma % 11 < 2 ? 0 : 11 - soma % 11
      if (resultado !== parseInt(digitos.charAt(1))) {
        return false
      }
      return true
    },
    onSearchPontoFocal (pontofocal) {
      if (pontofocal) {
        loading.push()
        let documentValue = pontofocal.document.value && pontofocal.document.value.toString().replace(/[^\d]+/g, '')
        let documentValid

        if (documentValue.length === 11) {
          documentValid = this.validateCpf(documentValue)
        } else {
          documentValid = this.validateCnpj(documentValue)
        }

        if (!documentValid) {
          toast.warning('Documento inválido')
          pontofocal.document.value = ''
        } else {
          PontoFocalRepository.GetByDocument(documentValue)
            .then((response) => {
              console.log(response)
              if (response.data && response.data.content.length !== 0) {
                let content = response.data.content[0]
                pontofocal.nome.value = content.nome
                pontofocal.dataNascimento.value = content.dataNascimento.split('T')[0].split('-').reverse().join('/')
                pontofocal.email.value = content.email
                pontofocal.telefone.value = content.telefone
                pontofocal.cargo.value = content.cargo.id
              }
              loading.close()
            })
            .catch(this.onException)
          loading.close()
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/person/components/add/personAdd.vue